/**
 *
 * Visibility
 *
 */
import React, { useEffect } from 'react';

import { useDispatch } from 'react-redux';
import { Route, Routes } from 'react-router-dom';

import { useFlags } from 'app/flagsmith';
import { featureFlags, isFeatureEnabled } from 'app/flagsmith/features';
import { FilterRouter } from 'components/FilterView';
import { JitRequests } from 'containers/Jit/JitRequests/Loadable';
import { Data } from 'containers/Visibility/Data/Loadable';
import { SecurityGraphNext } from 'containers/Visibility/SecurityGraphNext';
import { actions } from 'containers/Visibility/slice';
import { LegacyVulnerabilitiesPage } from 'containers/Visibility/Vulnerabilities/LegacyVulnerabilitiesPage';
import { VulnerabilityV3Page } from 'containers/Visibility/Vulnerabilities/VulnerabilityV3Page';
import { useSearchParams } from 'hooks/useSearchParams';
import { useInjector } from 'utils/inject';

import { IncidentResponse } from './IncidentResponse/Loadable';
import { visibilitySaga } from './saga';
import { reducer, sliceKey } from './slice';

export const Visibility = () => {
  useInjector(sliceKey, reducer, visibilitySaga);
  const { new_vuln_dashboard: newVulnerabilityDashboard } = useFlags([
    featureFlags.vulnerabilityV3,
  ]);
  const isNewVulnerabilityDashboardEnabled = isFeatureEnabled(
    newVulnerabilityDashboard,
  );

  const dispatch = useDispatch();

  const { map = false } = useSearchParams();
  useEffect(() => {
    if (map) {
      dispatch(actions.openMap());
    }
  }, [dispatch, map]);

  return (
    <Routes>
      <Route element={<FilterRouter path="/visibility/security-graph" />}>
        <Route path="security-graph" element={<SecurityGraphNext />} />
      </Route>
      <Route element={<FilterRouter path="/visibility/data" />}>
        <Route path="data" element={<Data />} />
      </Route>
      <Route element={<FilterRouter path="/visibility/vulnerability" />}>
        <Route
          path="vulnerability/*"
          element={
            isNewVulnerabilityDashboardEnabled ? (
              <VulnerabilityV3Page key="vulnerability-v3" />
            ) : (
              <LegacyVulnerabilitiesPage key="legacy" />
            )
          }
        />
      </Route>
      <Route element={<FilterRouter path="/visibility/activity" />}>
        <Route path="activity/*" element={<IncidentResponse />} />
      </Route>
      <Route element={<FilterRouter path="/visibility/jit-requests" />}>
        <Route path="jit-requests" element={<JitRequests />} />
      </Route>
    </Routes>
  );
};
